import React, { useLayoutEffect } from "react";

import { Icon } from "components/Icon";
import { connect } from "react-redux";
import { pageIdLogObject } from "utils/pageIdLogger";
import BaseNav from "components/base/BaseNav";
import styled from "styled-components";

import { withRouter } from "react-router-dom";
import { Dropdown } from "rsuite";

const PageTabs = ({
    isMobile,
    activeTab,
    onSelect,
    isClient = false,
    menuItems = [],
}) => {

    useLayoutEffect(() => {
        if (!isClient) {
            pageIdLogObject.lastTab = activeTab;
            return () => {
                pageIdLogObject.lastTab = null;
            }
        }
    }, [activeTab]);


    if (isMobile) {
        return (
            <Dropdown
                icon={<Icon icon="bars" />}
                appearance="ghost"
                placement={"bottomEnd"}
                onSelect={onSelect}
                activeKey={activeTab}
            >
                {menuItems.map(item => (
                    <Dropdown.Item key={item.id} eventKey={item.eventKey} disabled={item?.disabled || false}>{item.title}</Dropdown.Item>
                ))}
            </Dropdown>
        )
    }

    return (
        <StyledBaseNav
            activeKey={activeTab}
            onSelect={onSelect}
            appearance="tabs"
        >
            {menuItems.map(item => (
                <BaseNav.Item key={item.id} eventKey={item.eventKey} disabled={item?.disabled || false}>{item.title}</BaseNav.Item>
            ))}
        </StyledBaseNav>
    )
};

export default connect(
    null,
    {}
)(withRouter(PageTabs));


const StyledBaseNav = styled(BaseNav)`
    && {
        @media (max-width: 767px) {
            overflow: auto;
        }
    }
`;